import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { motion } from "framer-motion";
import { isNumber } from "lodash";
import { useMemo } from "react";
import { usePostRedeemStickerMutation } from "../../services/apiSlice";
import Button from "./../../components/v6/Button";
import { HttpStatusCode } from "axios";

const Step2 = ({ item, handleNext }) => {
  const date = new Date();

  const [onRedeem] = usePostRedeemStickerMutation();

  const onClick = async () => {
    if (["COIN", "XP"].includes(item?.reward?.type)) {
      try {
        const payload = { reward_id: item.reward.reward_id };
        const response = await onRedeem(payload).unwrap();

        if (response.status === HttpStatusCode.Ok) {
          if (handleNext) handleNext(3);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      if (handleNext) handleNext(3);
    }
  };

  const reward = useMemo(() => {
    if (!item?.reward) return "";
    const { reward } = item;

    const rewardQuantity = isNumber(reward.reward_quantity) ? reward.reward_quantity : "";

    switch (reward.type) {
      case "COIN":
        const coinTitle = `${reward.token} ${reward.token > 1 ? "coins" : "coin"}`;
        return coinTitle;
      case "XP":
        const xpTitle = `${reward.xp} XP`;
        return xpTitle;
      default:
        return `${rewardQuantity} x ${reward?.reward_name}`;
    }
  }, [item]);

  const renderCoinContent = () => {
    return (
      <>
        <h2 className="text-base font-bold text-center text-primary">Redeemed!</h2>
        <img
          src={
            item?.reward?.reward_image
              ? `${process.env.REACT_APP_URL_IMAGE}/${item?.reward?.reward_image?.file_path}`
              : "/images/brand.jpg"
          }
          alt=""
          className="rounded-xl w-full h-60 object-cover"
        />
        <p className="text-2xl leading-none text-primary font-bold">{reward}</p>
        {!["COIN", "XP"].includes(item?.reward?.type) && (
          <p className="text-dark-gray text-lg leading-none text-center">Show this to the staff</p>
        )}
        <Button handleClick={onClick} className="w-full">
          Next
        </Button>
      </>
    );
  };

  const renderDiscountContent = () => {
    return (
      <>
        <h2 className="text-[32px] leading-[38px] max-xs:text-3xl font-bold text-primary text-center -tracking-[0.64px] whitespace-nowrap">
          Redemption Successful
        </h2>
        <p className="text-center text-base w-3/5 text-dark-gray font-medium">
          Please show this to staff for verification
        </p>
        <div className="h-[135px] max-xs:h-[120px] w-full flex flex-col justify-center items-center gap-3 bg-[#EDF8B2] rounded-xl [&>p]:text-primary [&>p]:font-bold">
          <p className="text-[48px] leading-[58px] max-xs:text-3xl">
            {item?.reward?.discount_percentage}% discount
          </p>
          <p className="text-2xl leading-[29px] max-xs:text-xl">at {item?.reward?.discount_at}</p>
        </div>
        <div className="h-[135px] max-xs:h-[120px] w-full flex flex-col justify-center items-center gap-3 bg-[#ECEEFF] rounded-xl [&>p]:text-primary [&>p]:font-bold">
          <p className="text-2xl leading-[29px] max-xs:text-xl">
            {format(date, "dd MMM yyyy", { locale: enUS }).toUpperCase()}
          </p>
          <p className="text-[48px] leading-[58px] max-xs:text-3xl">
            {format(date, "hh:mm a", { locale: enUS })}
          </p>
        </div>
        <Button handleClick={onClick} className="w-full">
          Complete
        </Button>
      </>
    );
  };

  return (
    <motion.div
      key="step2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center gap-6"
    >
      {item?.reward?.type === "DISCOUNT" ? renderDiscountContent() : renderCoinContent()}
    </motion.div>
  );
};

export default Step2;
